import { useTranslate } from "ra-core";
import { MegaphoneOff } from "lucide-react";

import { cn } from "@/lib/utils";

import type { WhatsAppMessagingCapability } from "../types";

/**
 * Marketing opt-out is a broadcast concern, not a reply concern: WhatsApp lets
 * us answer any inbound message freeform inside the 24h window, whatever the
 * contact said about marketing. The dashboard API therefore reports the
 * opt-out on `opt_in_status` without closing the window. This renders it as a
 * quiet hint so operators know why templates and broadcasts stay off for the
 * contact while the reply box is open.
 */
export const WhatsAppMarketingOptOutNotice = ({
  capability,
  className,
}: {
  capability: WhatsAppMessagingCapability | null | undefined;
  className?: string;
}) => {
  const translate = useTranslate();
  if (capability?.opt_in_status !== "opted_out") return null;
  return (
    <p
      className={cn(
        "flex items-start gap-2 text-xs text-muted-foreground",
        className,
      )}
    >
      <MegaphoneOff className="mt-0.5 size-3.5 shrink-0" aria-hidden />
      <span>{translate("crm.whatsapp.marketing_opted_out_hint")}</span>
    </p>
  );
};
